<div class="uptime-monitors-details">
  <div class="uptime-summary-row" role="group" aria-label="Resumen del periodo">
    <div
      class="summary-chip"
      matTooltip="Número de monitores del producto que están activos (is_active=true) en este periodo."
      matTooltipPosition="above"
    >
      <span class="summary-chip-label">Activos</span>
      <span class="summary-chip-value">{{ uptimeData().active_company_product_status_monitors_count }}</span>
    </div>
    <div
      class="summary-chip"
      matTooltip="Monitores activos que cumplen ambos checks: recurrencia esperada y uptime mínimo del periodo."
      matTooltipPosition="above"
    >
      <span class="summary-chip-label">Válidos</span>
      <span class="summary-chip-value">{{ uptimeData().valid_monitors_count }}</span>
    </div>
    <div
      class="summary-chip"
      matTooltip="Tiempo en uptime sobre el tiempo monitorizado de todos los monitores activos en el periodo."
      matTooltipPosition="above"
    >
      <span class="summary-chip-label">Uptime / monitorizado</span>
      <span class="summary-chip-value"
        >{{ uptimeData().uptime_seconds | SecondsToHourString }} / {{ uptimeData().monitored_seconds | SecondsToHourString }}</span
      >
    </div>
  </div>

  @if (uptimeData().uptime_monitor_items.length === 0) {
    <p class="no-data">No hay monitores activos para mostrar en este periodo.</p>
  } @else {
    <div class="monitor-scroll">
      @for (uptime_monitor_item of uptimeData().uptime_monitor_items; track $index) {
        <article class="monitor-card">
          <header class="monitor-card-header">
            <span class="monitor-card-title">Monitor #{{ $index + 1 }}</span>
            <span
              class="status-badge"
              [class.status-badge--ok]="uptime_monitor_item.is_valid_monitor"
              [class.status-badge--warn]="!uptime_monitor_item.is_valid_monitor"
            >
              {{ uptime_monitor_item.is_valid_monitor ? 'Válido' : 'No válido' }}
            </span>
          </header>

          <dl class="monitor-dl">
            <div class="monitor-dl-row">
              <dt>Recurrencia</dt>
              <dd>cada {{ uptime_monitor_item.exec_every_n_minutes }} min</dd>
            </div>
            <div class="monitor-dl-row">
              <dt>Última ejecución</dt>
              <dd>
                {{
                  uptime_monitor_item.last_exec_started_at
                    ? (uptime_monitor_item.last_exec_started_at | date: 'dd/MM/yyyy HH:mm')
                    : 'Sin ejecuciones en el periodo'
                }}
              </dd>
            </div>
            <div class="monitor-dl-row">
              <dt>Último estado</dt>
              <dd>
                @if (!uptime_monitor_item.last_exec_status) {
                  <span class="exec-pill exec-pill--muted">Sin estado</span>
                } @else if (uptime_monitor_item.last_exec_status === 'healthy') {
                  <span class="exec-pill exec-pill--ok">{{ uptime_monitor_item.last_exec_status }}</span>
                } @else if (uptime_monitor_item.last_exec_status === 'unhealthy') {
                  <span class="exec-pill exec-pill--bad">{{ uptime_monitor_item.last_exec_status }}</span>
                } @else {
                  <span class="exec-pill exec-pill--muted">{{ uptime_monitor_item.last_exec_status }}</span>
                }
              </dd>
            </div>
            <div class="monitor-dl-row">
              <dt>Uptime en periodo</dt>
              <dd>
                {{ uptime_monitor_item.uptime_ratio_prcnt | number: '1.0-1' }}%
                <span class="muted"
                  >({{ uptime_monitor_item.uptime_seconds | SecondsToHourString }} /
                  {{ uptime_monitor_item.monitored_seconds | SecondsToHourString }})</span
                >
              </dd>
            </div>
            <div class="monitor-dl-row monitor-dl-row--checks">
              <dt>Checks</dt>
              <dd class="checks-dd">
                <span
                  class="check-pill"
                  [class.check-pill--ok]="uptime_monitor_item.is_executing_with_expected_recurrence"
                  [class.check-pill--ko]="!uptime_monitor_item.is_executing_with_expected_recurrence"
                >
                  Recurrencia {{ uptime_monitor_item.is_executing_with_expected_recurrence ? 'OK' : 'KO' }}
                </span>
                <span
                  class="check-pill"
                  [class.check-pill--ok]="uptime_monitor_item.is_good_uptime"
                  [class.check-pill--ko]="!uptime_monitor_item.is_good_uptime"
                >
                  Uptime {{ uptime_monitor_item.is_good_uptime ? 'OK' : 'KO' }}
                </span>
              </dd>
            </div>
          </dl>
        </article>
      }
    </div>
  }
</div>
